<template>
  <div class="category-card"
       :class="{active: value === category.category_name}"
       @click="change(category.category_name)"
  >
    <img class="category-img" :src="getFromStorage(category.category_image)" alt="">
    <span class="name" v-text="categoryName"></span>
  </div>
</template>

<script>
import { getFromStorage } from "@/helpers/backendStorage";

export default {
  name: "CategoryCard",

  props: {
    category: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
    }
  },

  computed: {
    categoryName() {
      return this.translate(this.category.category_name)
    }
  },

  methods: {
    getFromStorage,
    change(newValue) {
      this.$emit('change', newValue);
      this.$emit('input', newValue);
    }
  }
}
</script>

<style scoped lang="scss">
  .category-card {
    max-height: 125px;
    max-width: 85px;
    background-color: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.16);
    padding: 5px 8px;
    text-align: center;
    cursor: pointer;
    transition: all ease 0.3s;
    user-select: none;

    &:hover {
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

      .category-img {
        transform: scale(1.1);
      }
    }

    &.active {
      box-shadow: 0 3px 6px rgba(61, 176, 199, 0.7);
    }

    .category-img {
      width: 100%;
      height: 100%;
      max-width: 68px;
      max-height: 68px;
      transition: all ease 0.3s;
    }
    .name {
      font-size: 12px;
      font-family: neue-haas-grotesk-display, sans-serif;
      display: block;
      transition: all ease 0.3s;
      padding: 8px 0 4px;
    }
  }
</style>
